import { ReactNodeViewRenderer } from "@tiptap/react";
import { mergeAttributes, Node } from "@tiptap/core";
import { ConditionalBlockView } from "./ConditionalBlockView";

export const ConditionalBlockNode = Node.create({
  name: "conditional-block",
  group: "block",
  content: "condition* block+",
  defining: true,

  addAttributes() {
    return {
      logic: { default: "and" },
      _key: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "conditional-block" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["conditional-block", mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ConditionalBlockView);
  },

  addCommands() {
    return {
      insertConditionalBlock:
        (logic = "and", conditions = []) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { logic },
            content: [
              ...conditions.map((c) => ({
                type: "condition",
                attrs: c,
              })),
              {
                type: "paragraph",
                content: [
                  { type: "text", text: "Conditional content goes here..." },
                ],
              },
            ],
          });
        },
      updateConditionalBlock:
        (pos, logic = "and", conditions = []) =>
        ({ tr, state, dispatch }) => {
          if (pos == null) return false;

          const { schema } = state;
          const node = tr.doc.nodeAt(pos);
          if (!node) return false;

          const newNode = schema.nodes["conditional-block"].create(
            { logic, _key: Math.random().toString(36).slice(2) },
            [
              ...conditions.map((c) =>
                schema.nodes["condition"].create({
                  ...c,
                  _id: Math.random().toString(36).slice(2),
                })
              ),
              schema.nodes.paragraph.create(
                {},
                schema.text("Conditional content goes here...")
              ),
            ]
          );

          const end = pos + node.nodeSize;
          tr.replaceWith(pos, end, newNode);

          if (dispatch) dispatch(tr);
          return true;
        },
    };
  },
});
